import {
  SanityProductFragment,
  SanityProductVariantFragment,
} from '@data/sanity/queries/types/product'
import { getOptionLabel } from '@lib/product'

import ProductOption from './product-option'

interface ProductFormProps {
  product: SanityProductFragment
  activeVariant: SanityProductVariantFragment
  onVariantChange: (variantId: number) => void
  onPreviewVariant: (variantId: number | null) => void
}

const ProductForm = ({
  product,
  activeVariant,
  onVariantChange,
  onPreviewVariant,
}: ProductFormProps) => {
  const options =
    product.options.filter(({ values }) => values.length > 0) ?? []

  if (options.length === 0) {
    return null
  }

  return (
    <div>
      {options.map((option, index) => (
        <ProductOption
          key={option.name}
          label={getOptionLabel(product.optionNames ?? [], option)}
          position={index}
          option={option}
          optionSettings={product.optionSettings ?? []}
          variants={product.variants ?? []}
          activeVariant={activeVariant}
          onChange={(variant) => onVariantChange(variant.id)}
          onPreview={(variant) => onPreviewVariant(variant?.id ?? null)}
        />
      ))}
    </div>
  )
}

export default ProductForm
